import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PopupService } from '../../../shared/modal/popup.service';
import { ParamContext } from '../../../shared/service/param.context';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoryDetailsComponent } from './inventory-details.component';
import { UrlService } from '../../../shared/service/url.service';

@Component({
    selector: 'jhi-inventory-details-modal',
    templateUrl: './inventory-details-modal.component.html',
})
export class InventoryDetailsModalComponent implements OnInit {

    readonly url: SafeResourceUrl;

    constructor(private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private context: ParamContext,
                public activeModal: NgbActiveModal,
                private urlService: UrlService
    ) {
        const gid = this.route.snapshot.queryParams.gid;
        const url = '/ibpworkbench/controller/jhipster#/inventory-details?restartApplication' +
            '&cropName=' + context.cropName +
            '&programUUID=' + context.programUUID +
            '&gid=' + gid + '&modal';

        const safeUrl = this.urlService.buildSafeUrl(url);
        // Fall back to a blank page if the URL is not on the allowlist.
        this.url = safeUrl !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');

    }

    ngOnInit() {
        (<any>window).closeModal = () => {
            this.activeModal.close();
        };
    }

}

@Component({
    selector: 'jhi-inventory-details-popup',
    template: ''
})
export class InventoryDetailsPopupComponent implements OnInit {

    constructor(private popupService: PopupService) {
    }

    ngOnInit(): void {
        const modal = this.popupService.open(InventoryDetailsComponent as Component);
    }

}
